import { Injectable, RendererFactory2, DOCUMENT, inject } from '@angular/core';

import { LocaleService } from './locale/locale.service';

import type { Renderer2 } from '@angular/core';

import type { LocaleLanguage } from './locale/locale.domain';
import type { PostBootstrapInit } from './post-bootstrap-init';

@Injectable({
  providedIn: 'root'
})
export class PageLangService implements PostBootstrapInit {
  private readonly document = inject<Document>(DOCUMENT);
  private readonly localeService = inject<LocaleService>(LocaleService);

  private renderer: Renderer2;

  constructor() {
    const rendererFactory = inject<RendererFactory2>(RendererFactory2);

    this.renderer = rendererFactory.createRenderer(null, null);
  }

  init(): void {
    this.setPageLang(this.localeService.getLanguage());
  }

  setPageLang(lang: LocaleLanguage): void {
    if (this.document !== undefined) {
      this.renderer.setAttribute(this.document.documentElement, 'lang', lang);
    }
  }
}
